import type { ProductAttributeSelectorProps } from '../config.types';
import { useProductAttribute } from '../useProductAttribute';
import React from 'react';

type AttributeSelectorProps = {
  attributeId: string;
} & ProductAttributeSelectorProps;

/**
 * Renders the Selector component associated with a product Attribute
 */
export const AttributeSelector = (props: AttributeSelectorProps) => {
  const attribute = useProductAttribute(props.attributeId);

  const Element = attribute?.component;
  if (!Element) return null;

  return (
    <Element
      {...props}
      {...attribute?.componentProps}
    />
  );
};
